"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatusOverview = void 0;
const luxon_1 = require("luxon");
const DateManagement_1 = require("../../../../utils/DateManagement");
const PunchCorrectionStatusTypes_1 = require("../../PunchCorrectionStatusTypes");
const react_i18next_1 = require("react-i18next");
function useStatusOverview({ dateTime, initialDateTime, militaryTime, reason, type, status }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dateTimeObj = luxon_1.DateTime.fromISO(dateTime);
    const timeString = (0, DateManagement_1.getTimeString)(dateTimeObj, militaryTime);
    const dateString = dateTimeObj.toLocaleString(luxon_1.DateTime.DATE_FULL);
    let initialTimeString, initialDateString;
    if (initialDateTime) {
        const initialDateTimeObj = luxon_1.DateTime.fromISO(initialDateTime);
        initialTimeString = (0, DateManagement_1.getTimeString)(initialDateTimeObj, militaryTime);
        initialDateString = initialDateTimeObj.toLocaleString(luxon_1.DateTime.DATE_FULL);
    }
    const { statusKey, chipBgColor } = getStatusMapping(status, reason, type);
    const typeLocaleMapping = {
        [PunchCorrectionStatusTypes_1.PunchCorrType.DELETE_PUNCH]: t('time_and_attendance_PunchCorrectionType_DeletedPunch'),
        [PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH]: t('time_and_attendance_PunchCorrectionType_MissedPunch'),
        [PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH]: t('time_and_attendance_PunchCorrectionType_EditedPunch'),
        [PunchCorrectionStatusTypes_1.PunchCorrType.A_TO_Z_CLOCK_PUNCH]: t('time_and_attendance_PunchCorrectionType_AtoZClock')
    };
    const ariaLabel = t('time_and_attendance_StatusOverview_ariaLabel', {
        type: typeLocaleMapping[type] || type,
        date: timeString,
        time: timeString,
        status: t(statusKey)
    });
    return {
        ariaLabel,
        statusKey,
        chipBgColor,
        title: typeLocaleMapping[type] || type,
        timeString,
        dateString,
        initialTimeString,
        initialDateString
    };
}
exports.useStatusOverview = useStatusOverview;
const statusToUIKey = {
    success: {
        statusKey: 'time_and_attendance_StatusOverview_Status_Accepted',
        chipBgColor: 'green'
    },
    pending: {
        statusKey: 'time_and_attendance_StatusOverview_Status_Pending',
        chipBgColor: 'yellow'
    },
    failed: {
        statusKey: 'time_and_attendance_StatusOverview_Status_NotAccepted',
        chipBgColor: 'red'
    }
};
const getStatusMapping = (status, reason, type) => {
    let statusObj = null;
    switch (status) {
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.SUBMITTED_SUCCESSFULLY:
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.COMPLETED_SUCCESSFULLY:
            statusObj = statusToUIKey.success;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.IN_PROGRESS:
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.PENDING:
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED_PENDING_RETRY:
            statusObj = statusToUIKey.pending;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED:
            statusObj = statusToUIKey.failed;
            if ((type === PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH ||
                type === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH) &&
                reason === PunchCorrectionStatusTypes_1.PunchCorrReason.DUPLICATE) {
                statusObj = statusToUIKey.pending;
            }
            break;
        default:
            statusObj = statusToUIKey.failed;
    }
    return statusObj;
};
